(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crozel-size-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.czReady === '1') return;
      root.dataset.czReady = '1';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cz-tab]'));
      var panels = {};
      Array.prototype.forEach.call(root.querySelectorAll('[data-cz-panel]'), function (p) {
        panels[p.getAttribute('data-cz-panel')] = p;
      });

      function select(key, focus) {
        if (!panels[key]) return;
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-cz-tab') === key;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
        });
        Object.keys(panels).forEach(function (k) { panels[k].hidden = k !== key; });
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t.getAttribute('data-cz-tab')); });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          select(tabs[(i + d + tabs.length) % tabs.length].getAttribute('data-cz-tab'), true);
        });
      });

      Array.prototype.forEach.call(root.querySelectorAll('[data-cz-unit]'), function (seg) {
        var group = seg.getAttribute('data-cz-unit');
        var labels = root.querySelectorAll('[data-cz-unit-label="' + group + '"]');
        var cells = group === 'ring'
          ? root.querySelectorAll('[data-cz-mm]')
          : root.querySelectorAll('[data-cz-in]');

        seg.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-cz-set]');
          if (!btn || !seg.contains(btn)) return;
          var unit = btn.getAttribute('data-cz-set');
          Array.prototype.forEach.call(seg.querySelectorAll('[data-cz-set]'), function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          Array.prototype.forEach.call(labels, function (el) { el.textContent = '(' + unit + ')'; });
          Array.prototype.forEach.call(cells, function (td) {
            if (group === 'ring') {
              var mm = parseFloat(td.getAttribute('data-cz-mm'));
              if (isNaN(mm)) return;
              td.textContent = unit === 'mm' ? td.getAttribute('data-cz-mm') : (mm / 25.4).toFixed(2);
            } else {
              td.textContent = unit === 'in' ? td.getAttribute('data-cz-in') : td.getAttribute('data-cz-cm');
            }
          });
        });
      });
    }

    function boot(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-cz-guide]'), init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
